import styled from 'styled-components';

const StickoutBanner = styled.div`
  box-sizing: content-box;
  background-color: white;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  max-width: 1240px;
  width: 100%;

  ${props => props.theme.isXXLarge && `
    width: 1240px;
  `};

  ${props => props.theme.isXLarge && `
    border-radius: 6px;
  `};

  ${props => !props.theme.isXLarge && props.theme.isLarge && `
    width: calc(100% + 64px);
  `};
`;

export default StickoutBanner;
